import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { LayoutService } from '../core/service/layout.service';
import { PortalUser } from './model/PortalUser';
import { SsoUser } from './model/SsoUser';
import { PreregUsers } from './model/preregUsers';
@Component({
    templateUrl: './accounts.component.html',
    styleUrls: ['./accounts.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AccountsComponent implements OnInit{
  portalUser: PortalUser | undefined;
  ssoUser: SsoUser | undefined;
  loading = false;
  preregUser: PreregUsers | undefined;
  subHeading = '';
  constructor( public layout: LayoutService) { }

  ngOnInit() {
    this.SubHeading;
  }

  onBackBtnClick() {
    this.preregUser = undefined;
    this.SubHeading;
}

get SubHeading() {
return  this.subHeading = (!this.preregUser) ? 'Lookup user accounts and perform actions to activate, deactivate or unlock accounts' :
  'Lookup student details';
}


}
